import { render, staticRenderFns } from "./FrequentTripSavingsOverview.vue?vue&type=template&id=bcd4b4be"
import script from "./FrequentTripSavingsOverview.vue?vue&type=script&lang=ts"
export * from "./FrequentTripSavingsOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports